export const environment = {
    env: 'qa',
    production: true,
    rollBarId: '6cc3200ad9594700b33b11d945d02914',
    supportPath: 'https://api.support.qa.monsido.com/',
    apiEnvs: [
        {
            name: 'QA1',
            url: 'https://app1.qa.monsido.com',
        },
    ],
    oauthClientId: '_COuq8L3w213xo3tmk-EaeE9IJJ1IsYuNr8eXc4AJEo',
    oauthClientSecret: 'U4EdL9WfRWds5aG8vujNQDN0Qf1G6M3X9j9GjW7vR74',
    monsidoPath: 'https://login.qa.monsido.com/',
    oauthScopes: 'reseller admin reseller_admin super_admin',
    monsidoResellers: [
        {
            name: 'Monsido1',
            id: 1,
        },
    ],
};
